import { useSnackbar } from 'notistack';
import { useQuery } from 'react-query';
import { useHttp } from 'shared/providers/provide-http';
import { EndUserDropdown, TableDataResponse } from 'types/backend';

export function useGetEndUserDropdown(customerNumber: string) {
    const { enqueueSnackbar } = useSnackbar();
    const http = useHttp();
    const endUserDropdownResponse = useQuery<TableDataResponse<EndUserDropdown>, Error>(
        ['enduserdropdown', customerNumber],
        async () => {
            const { data } = await http.post(`api/enduser/dropdown/${customerNumber}`, {
                FilterModel: {
                    Items: [],
                },
                SortModel: [],
            });
            return (
                {
                    ...data,
                    rows: data?.rows.sort((a: EndUserDropdown, b: EndUserDropdown) =>
                        a.endusername.localeCompare(b.endusername)
                    ),
                } || []
            );
        },
        {
            onError: (error) => enqueueSnackbar(error.message, { variant: 'error' }),
            keepPreviousData: true,
            refetchOnWindowFocus: false,
        }
    );
    return endUserDropdownResponse;
}
